module.exports = __webpack_public_path__ + "img/choose-up-Up Vacanta-disabled.44820fd9.png";